import { configureStore } from '@reduxjs/toolkit';
import allReducer from '../redux/reducers';
import authReducer from '../redux/templete/authSlice'
import adminAuthReducer from '../redux/templete/adminAuthSlice'

export const store = configureStore({
    reducer: {
        allReducer,
        authReducer,
        adminAuthReducer,
    }
});



